<template>
    <div>
        <template v-if="busy">
            <CenteredMessage :spinner="busy">
                <template>Lädt Widget...</template>
            </CenteredMessage>
        </template>
        <template v-else>
            <BarChart v-if="loaded" :chartdata="chartData" />
        </template>
    </div>
</template>

<script>
import WidgetContent from "@/mixins/Widget/WidgetContent";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import BarChart from "@/components/BarChart/BarChart";

export default {
    name: "Mitgliederstatistik",
    mixins: [WidgetContent],
    components: {
        CenteredMessage,
        BarChart
    },
    props: ["url"],
    data() {
        return {
            loaded: false,
            chartData: {}
        };
    },
    methods: {
        process(items) {
            items = items.collection;

            var chartData = {
                labels: [],
                datasets: []
            };

            var dataSetAgeTotalMean = {
                type: "line",
                label: "Durschnitt (gesamt)",
                backgroundColor: "#ff0000",
                borderColor: "rgba(255, 0, 0, 0.75)",
                data: [],
                fill: false,
                pointRadius: 0
            };
            var datasetAge = {
                label: "Durschnittsalter",
                data: []
            };

            var totalMean = 0;
            for (const item of items) {
                chartData.labels.push(item.label);
                datasetAge.data.push(item.data.age);
                totalMean += Number(item.data.age);
            }

            totalMean = totalMean / items.length;
            for (const _ of items) {
                dataSetAgeTotalMean.data.push(totalMean);
            }

            chartData.datasets.push(dataSetAgeTotalMean, datasetAge);

            this.chartData = chartData;
            this.loaded = !this.loaded;
        }
    }
};
</script>
